/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The status of the SQL engine
*/
export enum SqlEngineStatus {
  SQL_ENGINE_STATUS_CREATING = 'CREATING',
  SQL_ENGINE_STATUS_CREATE_FAILED = 'CREATE_FAILED',
  SQL_ENGINE_STATUS_STOPPED = 'STOPPED',
  SQL_ENGINE_STATUS_STARTING = 'STARTING',
  SQL_ENGINE_STATUS_STARTED = 'STARTED',
  SQL_ENGINE_STATUS_STOPPING = 'STOPPING',
  SQL_ENGINE_STATUS_DELETING = 'DELETING'
}
